'use client';
import { serializeStyles } from '@emotion/serialize';
import { insertStyles, getRegisteredStyles } from '@emotion/utils';
import { useEmotionCache } from '../../../../theming/propagation/ThemeProvider.js';
import { useGuaranteedMemo } from '../../../../modules/memo/impl/useGuaranteedMemo.js';
import { clsx } from './clsx/clsx.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var refPropertyName = "ref";
var getNestedSelectorRef = function(raws) {
    var xref = undefined;
    if (raws.length !== 1) {
        return {
            raws: raws,
            xref: xref
        };
    }
    var firstStyle = raws[0];
    if (!_instanceof(firstStyle, Object)) {
        return {
            raws: raws,
            xref: xref
        };
    }
    if (!(refPropertyName in firstStyle)) {
        return {
            raws: raws,
            xref: xref
        };
    }
    xref = firstStyle[refPropertyName];
    var firstStyleCopy = _extends({}, firstStyle);
    delete firstStyleCopy[refPropertyName];
    return {
        raws: [
            firstStyleCopy
        ],
        xref: xref
    };
};
var mergeClasses = function(registered, className, css) {
    var registeredStyles = [];
    /*
     * @emotion
     *
     * Из переданной строки classNames выбирает имена классов, которые содержатся в RegisteredCache
     * и добавляет в registeredStyles;
     *
     * Те имена классов, что не содержатся в RegisteredCache добавляет к возвращаемому набору классов.
     * */ var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
    if (registeredStyles.length < 2) {
        return className;
    }
    return rawClassName + css(registeredStyles);
};
var useCSS = function() {
    var cache = useEmotionCache();
    return useGuaranteedMemo(function() {
        var css = function() {
            for(var _len = arguments.length, stylesWithXRef = new Array(_len), _key = 0; _key < _len; _key++){
                stylesWithXRef[_key] = arguments[_key];
            }
            var _getNestedSelectorRef = getNestedSelectorRef(stylesWithXRef), xref = _getNestedSelectorRef.xref, raws = _getNestedSelectorRef.raws;
            /*
             * @emotion
             *
             * Сериализует стили, регистрирует их.
             * */ var styles = serializeStyles(raws, cache.registered);
            /*
             * @emotion
             *
             * Сбрасывает регистрацию стилей, добавляет стили к кэшу.
             * */ insertStyles(cache, styles, false);
            return cache.key + "-" + styles.name + (xref === undefined ? "" : " " + xref);
        };
        var cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return mergeClasses(cache.registered, clsx(args), css);
        };
        return {
            css: css,
            cx: cx
        };
    }, [
        cache
    ]);
};

export { useCSS };
